import { useEffect, useState } from "react";
import { type MessageKey, useI18n } from "~/i18n";
import type { BrazilRegion, BrazilUf } from "~/lib/domain/brazil-ufs";
import { RegionArt } from "./civic-art";

export const REGION_ART_LABEL: Record<BrazilRegion, MessageKey> = {
  north: "auth.map.regionArt.north",
  northeast: "auth.map.regionArt.northeast",
  centralWest: "auth.map.regionArt.centralWest",
  southeast: "auth.map.regionArt.southeast",
  south: "auth.map.regionArt.south",
};

export function CivicFigure({
  src,
  alt,
  fallbackSrc,
  className,
}: {
  src: string;
  alt: string;
  fallbackSrc?: string;
  className?: string;
}) {
  const [current, setCurrent] = useState(src);
  useEffect(() => {
    setCurrent(src);
  }, [src]);
  return (
    <figure className={className ? `civic-figure ${className}` : "civic-figure"}>
      <img
        src={current}
        alt={alt}
        loading="lazy"
        decoding="async"
        onError={() => {
          if (fallbackSrc && current !== fallbackSrc) setCurrent(fallbackSrc);
        }}
      />
    </figure>
  );
}

/** Vector regional art in the civic-figure frame (SEFAZ source pages). */
export function CivicRegionFigure({
  region,
  uf,
  className,
}: {
  region: BrazilRegion;
  uf?: BrazilUf | null;
  className?: string;
}) {
  const { t } = useI18n();
  return (
    <figure
      className={
        className ? `civic-figure civic-figure--art ${className}` : "civic-figure civic-figure--art"
      }
    >
      <RegionArt region={region} highlightUf={uf} label={t(REGION_ART_LABEL[region])} />
    </figure>
  );
}
